/* eslint-disable react/no-unknown-property */
import React from 'react';
import GenericPageLayoutBar, { GenericPageLayoutBarProps } from './bar/GenericPageLayoutBar';
import GenericPageLayoutContent, { GenericPageLayoutContentProps } from './content/GenericPageLayoutContent';
import * as styles from './GenericPageLayout.style';
import GenericPageLayoutContext from './GenericPageLayoutContext';
import GenericPageLayoutInnerContent, { GenericPageLayoutInnerContentProps } from './inner-content/GenericPageLayoutInnerContent';
import GenericPageLayoutTabs, { GenericPageLayoutTabsProps } from './tabs/GenericPageLayoutTabs';
import { GenericPageLayoutWrapperSize } from './wrapper/GenericPageLayoutWrapper';

export interface GenericPageLayoutProps extends React.AriaAttributes, React.PropsWithChildren {
  wrapperSize?: GenericPageLayoutWrapperSize,
}

interface DetailsLayoutComposition {
  Bar: React.FC<GenericPageLayoutBarProps>,
  /**
 * @deprecated
 */
  Tabs: React.FC<GenericPageLayoutTabsProps>,
  Content: React.FC<GenericPageLayoutContentProps>,
  InnerContent: React.FC<GenericPageLayoutInnerContentProps>,
}

const GenericPageLayout: React.FC<GenericPageLayoutProps> & DetailsLayoutComposition = ({
  wrapperSize,
  children,
  ...rest
}) => {
  const context = React.useMemo(() => ({
    wrapperSize,
  }), [wrapperSize]);

  return (
    <GenericPageLayoutContext.Provider value={context}>
      <div css={styles.base} {...rest}>
        {children}
      </div>
    </GenericPageLayoutContext.Provider>
  );
};

GenericPageLayout.Bar = GenericPageLayoutBar;
GenericPageLayout.Tabs = GenericPageLayoutTabs;
/**
 * @TODO: join Content and InnerContent in a unique component
 */
GenericPageLayout.Content = GenericPageLayoutContent;
GenericPageLayout.InnerContent = GenericPageLayoutInnerContent;

export default GenericPageLayout;
